


// PaymentStatusNote.js
import React from 'react'
import { Chip, Typography, Box } from '@mui/material'
import dayjs from 'dayjs'

const PaymentStatusNote = ({
  paymentStatus,
  dbPaymentStatus,
  sentDate,
  emailSent,
}) => {
  // Always display the saved DB value, not the working/dropdown value
  const displayStatus = dbPaymentStatus || paymentStatus
  const getStatusColor = (status) => {
    // Normalize to uppercase for comparison (handles both PAID and Paid)
    const normalizedStatus = status?.toUpperCase()
    switch (normalizedStatus) {
      case 'PAID':
        return '#4caf50' // Green
      case 'PENDING':
        return '#ff9800' // Orange
      case 'UNPAID':
      default:
        return '#f44336' // Red
    }
  }

  const getStatusIcon = (status) => {
    // Normalize to uppercase for comparison (handles both PAID and Paid)
    const normalizedStatus = status?.toUpperCase()
    switch (normalizedStatus) {
      case 'PAID':
        return '✓'
      case 'PENDING':
        return '⏳'
      case 'UNPAID':
      default:
        return '✗'
    }
  }

  const formatSentDate = (date) => {
    if (!date) return null
    return dayjs(date).format('MMM DD, YYYY')
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '4px',
        marginTop: '0px', // nudge down a bit
        marginLeft: '54px', // nudge right/forward from page start
        padding: '0px 12px',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '8px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        minWidth: 'max-content',
        whiteSpace: 'nowrap',
      }}
    >
      {/* Payment Status (row 1) */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Typography
          variant="body2"
          sx={{
            color: 'rgba(10, 5, 5, 0.8)',
            fontSize: '13px',
            fontWeight: 500,
            fontWeight: 'bold',
          }}
        >
          Payment:
        </Typography>
        <Chip
          label={`${getStatusIcon(displayStatus)} ${displayStatus || 'UNPAID'}`}
          sx={{
            backgroundColor: getStatusColor(displayStatus),
            color: 'white',
            fontWeight: 'bold',
            fontSize: '11px',
            height: '24px',
            '& .MuiChip-label': {
              paddingX: '8px',
            },
          }}
        />
      </Box>

      {/* Email Status (row 2) - always render as its own row */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Typography
          variant="body2"
          sx={{
            color: 'rgba(15, 6, 6, 0.8)',
            fontSize: '13px',
            fontWeight: 500,
            fontWeight: 'bold',
          }}
        >
          Email:
        </Typography>
        {emailSent ? (
          sentDate ? (
            <Chip
              label={`📧 ${formatSentDate(sentDate)}`}
              sx={{
                backgroundColor: 'rgba(76, 175, 80, 0.8)',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '11px',
                height: '24px',
                '& .MuiChip-label': {
                  paddingX: '8px',
                },
              }}
            />
          ) : (
            <Chip
              label="📧 Sent"
              sx={{
                backgroundColor: 'rgba(76, 175, 80, 0.8)',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '11px',
                height: '24px',
                '& .MuiChip-label': {
                  paddingX: '8px',
                },
              }}
            />
          )
        ) : (
          <Chip
            label="📧 Not Sent"
            sx={{
              backgroundColor: 'rgba(158, 158, 158, 0.8)',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '11px',
              height: '24px',
              '& .MuiChip-label': {
                paddingX: '8px',
              },
            }}
          />
        )}
      </Box>
    </Box>
  )
}

export default PaymentStatusNote
